'use client';

import { AdSlot } from '@/app_components/ads/Adslot';
import { useAdContext } from '@/app_lib/providers/AdProvider';
import { ContentPlacement } from '@/app_lib/types/analytics';
import { cn } from '@/app_lib/utils/utils';

interface RightRailFlexProps {
  className?: string;
  sticky?: boolean;
  index?: number;
}

export const RightRailFlex = ({ className, sticky = false, index }: RightRailFlexProps) => {
  const { pageAdConfig } = useAdContext();
  return (
    <div className={cn(sticky ? 'h-full' : 'h-[var(--rail-flex-height)] w-[var(--rail-flex-width)]', className)}>
      {/* Height of the right rail flex ad container */}
      <div
        className={cn(
          sticky && 'sticky top-[calc(var(--leaderboard-height)+var(--header-height)+var(--disclaimer-height))]',
        )}
        data-cy={ContentPlacement.RightRailFlex}
      >
        {pageAdConfig && (
          <AdSlot
            index={index}
            placementName='RightRailFlex'
            sticky={sticky}
          />
        )}
      </div>
    </div>
  );
};
